import type { Block } from '@w/content-blocks'
import type { BlockView, Overlay } from '../view-api'
import { ReviewApiContext, useReview } from './context'
import { ReviewView, DiffView, CommentView, CommentsView } from './views'
import { ReviewComments } from './comments'
import { ReviewSelectionToolbar } from './selection-toolbar'
import { ReviewBlockActions } from './block-actions'
import { ReviewCodeView } from './code'

export const blockViews: Partial<Record<Block['type'], BlockView>> = {
  review: ReviewView, diff: DiffView, comment: CommentView, comments: CommentsView, pre: ReviewCodeView,
}
const ReviewOverlay: Overlay = ({ api }) => {
  const { review, comments } = useReview()
  if (api.mode === 'answer' || !review) return null
  return <ReviewApiContext value={api}>
    <ReviewComments comments={comments ?? []} config={review} />
    <ReviewSelectionToolbar api={api} />
    <ReviewBlockActions api={api} />
  </ReviewApiContext>
}
export const overlays: Overlay[] = [ReviewOverlay]
